// Mock data for Sleek Business website

export const navigation = [
  { name: 'Home', href: '#home' },
  { name: 'Services', href: '#services' },
  { name: 'How It Works', href: '#how' },
  { name: 'About', href: '#why' },
  { name: 'Reviews', href: '#testimonials' },
  { name: 'Contact', href: '#contact' },
];

export const heroData = {
  eyebrow: 'Business Finance Made Simple',
  title: 'Fuel Your Business Growth Today',
  subtitle: 'Smart finance solutions built for UK businesses. From merchant cash advance to business loans and EPOS systems — everything you need in one place.',
  bullets: [
    'Business loans from £5k to £500k',
    'Approval within 24 hours',
    'Flexible repayment options',
    'Dedicated UK account manager',
  ],
};

export const trustBadges = [
  { label: '£120M+', sub: 'Funded to date' },
  { label: '10,000+', sub: 'UK businesses' },
  { label: '24hrs', sub: 'Fast approval' },
  { label: '4.9/5', sub: 'Trustpilot rating' },
];

export const services = [
  {
    id: 'business-loans',
    title: 'Business Loans',
    desc: 'Unsecured loans from £5,000 to £500,000 with fixed monthly repayments over 3–60 months.',
    icon: 'Landmark',
    highlights: ['No collateral required', 'Fixed monthly payments', 'Decision in 24 hours'],
  },
  {
    id: 'merchant-cash-advance',
    title: 'Merchant Cash Advance',
    desc: 'Repay a small percentage of your daily card takings — no fixed monthly repayments.',
    icon: 'CreditCard',
    highlights: ['Repay as you earn', 'No hidden fees', 'Funds in 48 hours'],
  },
  {
    id: 'card-terminals',
    title: 'Card Terminals',
    desc: 'Portable, countertop and mobile card machines with next-day settlement as standard.',
    icon: 'Smartphone',
    highlights: ['From £15/month', 'Contactless & chip', 'Next-day settlement'],
  },
  {
    id: 'epos-systems',
    title: 'EPOS Systems',
    desc: 'Complete point-of-sale systems with inventory, staff and reporting built in.',
    icon: 'MonitorSmartphone',
    highlights: ['Cloud-based', 'Inventory tracking', '24/7 support'],
  },
  {
    id: 'business-funding',
    title: 'Business Funding',
    desc: 'Flexible funding solutions tailored to your growth plans, including working capital.',
    icon: 'TrendingUp',
    highlights: ['£1k – £500k available', 'Fast decisions', 'Bespoke terms'],
  },
  {
    id: 'commercial-finance',
    title: 'Commercial Finance',
    desc: 'Asset finance, invoice finance and property-backed lending for larger commercial needs.',
    icon: 'Building2',
    highlights: ['Asset finance', 'Invoice factoring', 'Property lending'],
  },
];

export const fundingUses = [
  {
    title: 'Operational Growth',
    desc: 'Buy new equipment, expand inventory or fund the next phase of your business plan.',
    icon: 'TrendingUp',
  },
  {
    title: 'Marketing & Growth',
    desc: 'Attract new customers with campaigns that build brand visibility and drive sales.',
    icon: 'Megaphone',
  },
  {
    title: 'Refurbishment',
    desc: 'Refresh your premises to elevate customer experience and increase footfall.',
    icon: 'Building2',
  },
  {
    title: 'Tax, VAT & Wages',
    desc: 'Cover essential outgoings during quieter periods without disrupting operations.',
    icon: 'Receipt',
  },
];

export const howItWorks = [
  { step: '01', title: 'Apply Online', desc: 'Complete our 60-second enquiry form with basic business details.', icon: 'FileText' },
  { step: '02', title: 'Get a Quote', desc: 'A dedicated advisor calls you within 2 hours with tailored options.', icon: 'MessageCircle' },
  { step: '03', title: 'Accept Offer', desc: 'Review the terms and sign digitally — no paperwork, no branches.', icon: 'PenLine' },
  { step: '04', title: 'Get Funded', desc: 'Funds land in your business account within 24 to 48 hours.', icon: 'Wallet' },
];

export const whyChoose = [
  { title: 'No Hidden Fees', desc: 'Transparent pricing, no surprises, no early repayment charges ever.', icon: 'ShieldCheck' },
  { title: 'Repay As You Earn', desc: 'Flexible repayment models that protect your cash flow.', icon: 'Activity' },
  { title: 'Fast Decisions', desc: 'Approval in as little as 24 hours with minimal paperwork required.', icon: 'Zap' },
  { title: 'UK-Based Support', desc: 'Real people, real support — our team is based in the UK, seven days a week.', icon: 'Headphones' },
];

export const testimonials = [
  { name: 'James Whitmore', role: 'Owner, The Golden Fork Bistro', text: 'Been with Sleek Business for over 2 years now. Never disappointed. The team is reliable and the funding helped me open a second location.', rating: 5 },
  { name: 'Priya Sharma', role: 'Director, Verde Living Boutique', text: 'Signed up for a card machine and cash advance package. Rachel guided me through everything. Fast, professional and genuinely helpful.', rating: 5 },
  { name: 'Marcus Blake', role: 'Founder, Kingsway Motors', text: 'Arranged the whole funding deal through their team. Very transparent about fees. Daniel has been an excellent account manager throughout.', rating: 5 },
  { name: 'Sophie Ellington', role: 'Owner, Cloudberry Bakery', text: 'The daily repayment model saved my business during a slow winter. Repayments dropped naturally when takings did. Brilliant product.', rating: 5 },
  { name: 'Thomas Reyes', role: 'MD, Northgate Auto Services', text: 'Approved within a day. Funds landed in 48 hours. Used it to refit two of our workshops. Would recommend to any UK business owner.', rating: 5 },
];

export const faqs = [
  { q: 'How much can I borrow?', a: 'Advances typically range from £1,000 to £500,000 depending on your average monthly card takings and business turnover.' },
  { q: 'How quickly can I get funded?', a: 'Most applications are approved within 24 hours with funds released within 2–3 working days.' },
  { q: 'What are the eligibility criteria?', a: 'You need to be a UK-based business trading for at least 6 months and processing card payments regularly.' },
  { q: 'Is there a fixed repayment schedule?', a: 'For merchant cash advance, no — you repay a small pre-agreed percentage of your daily card takings. For loans, repayments are fixed monthly.' },
  { q: 'Will this affect my credit score?', a: 'Our initial quote is a soft search only and will not impact your credit score in any way.' },
  { q: 'Do you charge any upfront fees?', a: 'No. There are no application fees, arrangement fees or hidden charges of any kind.' },
];

export const partnerLogos = ['Visa', 'Mastercard', 'AMEX', 'Apple Pay', 'Google Pay', 'PayPal', 'Klarna'];

export const contactInfo = {
  email: 'info@sleekbusiness.co.uk',
  emailSupport: 'support@sleekbusiness.co.uk',
  phone: '0121 758 6892',
  address: 'Peel House, 34-44 London Road, Morden, SM4 5BT',
  hours: 'Mon–Fri  9:00 – 18:00',
};
